import React, { forwardRef, useImperativeHandle, } from 'react'
import { useIndexedDB } from 'react-indexed-db-hook';
import { useContactStore } from '../../../components/helper';

const GetContactDB = forwardRef(({ setContact }, ref) => {
    const { getAll } = useContactStore()
    useImperativeHandle(ref, () => ({
        async getContact() {
            let allCachedContact = await getAll()
            setContact(allCachedContact)
        },

    }));
    return (null)
})

export default GetContactDB
